import { render, staticRenderFns } from "./beneficiary.vue?vue&type=template&id=4a76c637&"
import script from "./beneficiary.vue?vue&type=script&lang=js&"
export * from "./beneficiary.vue?vue&type=script&lang=js&"
import style0 from "./beneficiary.vue?vue&type=style&index=0&id=4a76c637&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a76c637')) {
      api.createRecord('4a76c637', component.options)
    } else {
      api.reload('4a76c637', component.options)
    }
    module.hot.accept("./beneficiary.vue?vue&type=template&id=4a76c637&", function () {
      api.rerender('4a76c637', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/statistic/beneficiary.vue"
export default component.exports